import { useEffect, useRef, useState } from 'react';

import { getPreview } from './api';
import { LogService } from '../../services/log-service';

/**
 * @param {import('./config').DocumentTemplateType} documentType
 * @param {import('./config').PageDefinition} page
 * @param {import('./config').DocumentComponents} components
 * @returns {string} URL to the PDF preview
 */
export const useGetPreview = (documentType, page, components) => {
  const [preview, setPreview] = useState('');
  const previousBlobUrl = useRef('');
  const timeoutRef = useRef(/** @type {NodeJS.Timeout | null} */ (null));

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      getPreview(documentType, { page: page.data, components })
        .then((data) => {
          try {
            const blob = new Blob([data], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            if (previousBlobUrl.current) {
              URL.revokeObjectURL(previousBlobUrl.current);
            }
            previousBlobUrl.current = blobUrl;
            setPreview(blobUrl);
          } catch (error) {
            setPreview('');
            LogService.logError(new Error(`Converting to blob ${documentType}`, { cause: error }), {
              page,
              components,
            });
          }
        })
        .catch((error) => {
          setPreview('');
          LogService.logError(new Error(`Fetching preview for ${documentType}`, { cause: error }), {
            page,
            components,
          });
        });
    }, 1000);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [documentType, page, components]);

  useEffect(() => {
    return () => {
      if (previousBlobUrl.current) {
        URL.revokeObjectURL(previousBlobUrl.current);
      }
    };
  }, []);

  return preview;
};
